<template>
    <div>
        <div class="columns">
            <div class="column">
                <h2  class="has-text-weight-medium is-size-4"> Atributos</h2>
            </div>
        </div>

       <AttributesFormElement v-for="(el, index) in getAttributes" :data="el" :key="index" :index="index"/>
    
        <b-button @click="addAttribute" type="is-light m-r-20" rounded> 
            <b-icon icon="plus" size="is-small"></b-icon> Agregar atributo
        </b-button>

    
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import AttributesFormElement from "./AttributesFormElement.vue"

export default {
    components:{
        AttributesFormElement
    },
    
    computed:{
        ...mapGetters(['getAttributes'])
    },
    methods:{
        ...mapActions(['addAttribute']),
    }
}
</script>
